import { ButtonColor } from "../buttons/ButtonColor";
import { ButtonInterface } from "../buttons/ButtonInterface";
import { MenuItemBasic } from "./MenuItemBasic";

export class MenuItemHideMesh extends MenuItemBasic {
  constructor(
    protected override name: string,
    protected override mesh,
    protected override parentMesh,
    protected override type: string,
    protected override button: ButtonInterface = null,
    protected override items: MenuItemBasic[] = [],
    protected meshes,
    protected visibility
  ) {
    super(
      name,
      mesh,
      parentMesh,
      type,
      button,
      items
    );
    this.meshes = meshes;
    this.visibility = visibility;
    // this.button = new ButtonColor(name, color, false, clickable, false, false);
  }

}
